/* cs-cookie.js — bandeau RGPD Cloud Store CBD
   - 3 catégories : essentiels (always), analytics, marketing
   - Stockage : localStorage 'cs_consent_v1' + Shopify Customer Privacy API
   - LCP-safe : reveal après load + 200ms (banner pas dans le flow LCP)
   - CNIL-compliant : refuser aussi simple qu'accepter, granularité, persistant 13 mois
*/
(function () {
  'use strict';

  if (window.__csCookieInit) return;
  window.__csCookieInit = true;

  var STORAGE_KEY = 'cs_consent_v1';
  var STORAGE_VERSION = 1;
  var EXPIRY_MS = 13 * 30 * 24 * 60 * 60 * 1000; // 13 mois

  function readConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || data.v !== STORAGE_VERSION || !data.ts) return null;
      if (Date.now() - data.ts > EXPIRY_MS) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeConsent(analytics, marketing) {
    var data = {
      v: STORAGE_VERSION,
      ts: Date.now(),
      analytics: !!analytics,
      marketing: !!marketing
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) { /* localStorage disabled */ }

    // Shopify Customer Privacy API : dispatche aux Shopify Pixels, GA4, etc.
    try {
      if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!analytics,
          marketing: !!marketing,
          preferences: !!analytics, // notre catégorie 'analytics' couvre les préférences UX
          // Les pixels Meta / Pinterest / TikTok déclarent la finalité SALE_OF_DATA.
          // Shopify exige que TOUTES les finalités déclarées soient accordées pour
          // charger un Web Pixel : laisser false ici les bloque tous, même après
          // "Tout accepter". Le partage publicitaire relève du consentement marketing.
          sale_of_data: !!marketing
        }, function (errors) {
          if (errors) {
            // silencieux : Shopify peut ne pas être prêt sur certains contexts
          }
        });
      }
    } catch (e) { /* API absente */ }

    // Custom event consommable par d'autres scripts (ex: Clarity loader dans theme.liquid)
    try {
      document.dispatchEvent(new CustomEvent('cs:consent-changed', {
        detail: { analytics: !!analytics, marketing: !!marketing }
      }));
    } catch (e) { /* IE — pas notre cas */ }
  }

  // === DOM elements ===
  var banner = document.querySelector('[data-cs-cookie-banner]');
  var modalBackdrop = document.querySelector('[data-cs-cookie-modal]');
  if (!banner || !modalBackdrop) return; // banner pas rendu (settings disabled)

  var modal = modalBackdrop.querySelector('.cs-cookie-modal');
  var btnAccept = banner.querySelector('[data-cs-action="accept-all"]');
  var btnReject = banner.querySelector('[data-cs-action="reject-all"]');
  var btnCustomize = banner.querySelector('[data-cs-action="customize"]');
  var btnClose = modalBackdrop.querySelector('[data-cs-action="close"]');
  var btnRejectModal = modalBackdrop.querySelector('[data-cs-action="reject-modal"]');
  var btnSave = modalBackdrop.querySelector('[data-cs-action="save"]');
  var inputAnalytics = modalBackdrop.querySelector('[data-cs-toggle="analytics"]');
  var inputMarketing = modalBackdrop.querySelector('[data-cs-toggle="marketing"]');

  // === Banner show/hide ===
  function showBanner() {
    banner.hidden = false;
    // Force reflow so the transform transition fires
    void banner.offsetWidth;
    banner.classList.add('cs-cookie-banner--shown');
  }

  function hideBanner() {
    banner.classList.remove('cs-cookie-banner--shown');
    setTimeout(function () { banner.hidden = true; }, 380);
  }

  // === Modal show/hide ===
  var lastFocused = null;

  function showModal() {
    var existing = readConsent();
    if (inputAnalytics) inputAnalytics.checked = existing ? !!existing.analytics : false;
    if (inputMarketing) inputMarketing.checked = existing ? !!existing.marketing : false;

    lastFocused = document.activeElement;
    modalBackdrop.hidden = false;
    document.body.classList.add('cs-cookie-modal-open');
    void modalBackdrop.offsetWidth;
    modalBackdrop.classList.add('cs-cookie-modal-backdrop--shown');

    setTimeout(function () {
      var firstFocusable = modal.querySelector('button, [href], input, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    }, 100);
  }

  function hideModal() {
    modalBackdrop.classList.remove('cs-cookie-modal-backdrop--shown');
    document.body.classList.remove('cs-cookie-modal-open');
    setTimeout(function () { modalBackdrop.hidden = true; }, 240);
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch (e) {}
    }
  }

  // === Event handlers ===
  if (btnAccept) {
    btnAccept.addEventListener('click', function () {
      writeConsent(true, true);
      hideBanner();
    });
  }

  if (btnReject) {
    btnReject.addEventListener('click', function () {
      writeConsent(false, false);
      hideBanner();
    });
  }

  if (btnCustomize) {
    btnCustomize.addEventListener('click', showModal);
  }

  if (btnClose) {
    btnClose.addEventListener('click', hideModal);
  }

  if (btnRejectModal) {
    btnRejectModal.addEventListener('click', function () {
      if (inputAnalytics) inputAnalytics.checked = false;
      if (inputMarketing) inputMarketing.checked = false;
      writeConsent(false, false);
      hideModal();
      hideBanner();
    });
  }

  if (btnSave) {
    btnSave.addEventListener('click', function () {
      var analytics = inputAnalytics ? inputAnalytics.checked : false;
      var marketing = inputMarketing ? inputMarketing.checked : false;
      writeConsent(analytics, marketing);
      hideModal();
      hideBanner();
    });
  }

  // Click outside modal closes it
  modalBackdrop.addEventListener('click', function (e) {
    if (e.target === modalBackdrop) hideModal();
  });

  // Esc closes modal
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modalBackdrop.classList.contains('cs-cookie-modal-backdrop--shown')) {
      hideModal();
    }
  }, { passive: true });

  // === "Gérer mes cookies" link from anywhere (footer, Mimi, etc.) ===
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-cs-cookie-open]');
    if (trigger) {
      e.preventDefault();
      showModal();
    }
  });

  // === Age gate : une décision à la fois ===
  // Le bandeau et l'age gate sont tous deux en z-index 1100. Le bandeau étant rendu
  // après l'age gate dans theme.liquid, il passait devant et interceptait les taps sur
  // « Oui, j'ai 18 ans ou plus » : sur 390px, le centre du bouton renvoyait
  // DIV.cs-cookie-banner (audit 2026-07-30). On attend donc la validation de l'âge
  // avant de révéler le bandeau. L'age gate signale sa fermeture via la classe
  // `cs-agegate-verified` sur <html>.
  function ageGateOpen() {
    if (!document.getElementById('cs-agegate')) return false; // pas d'age gate sur cette page
    return !document.documentElement.classList.contains('cs-agegate-verified');
  }

  var ageGateObserver = null;
  function whenAgeGateClosed(cb) {
    if (!ageGateOpen()) { cb(); return; }
    if (ageGateObserver) return; // un callback est déjà en attente
    if (typeof MutationObserver !== 'function') { cb(); return; } // fallback : pas d'observer
    ageGateObserver = new MutationObserver(function () {
      if (ageGateOpen()) return;
      ageGateObserver.disconnect();
      ageGateObserver = null;
      cb();
    });
    ageGateObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  // === Initial state : show banner only if no decision recorded ===
  var existing = readConsent();
  if (!existing) {
    // LCP-safe reveal : on attend la fin du load + 200ms pour ne pas concurrencer
    // l'élément hero au paint initial.
    function reveal() {
      // Si l'utilisateur a navigué avant qu'on reveal (rare), skip.
      if (readConsent()) return;
      whenAgeGateClosed(function () {
        if (readConsent()) return;
        requestAnimationFrame(function () {
          showBanner();
        });
      });
    }

    if (document.readyState === 'complete') {
      setTimeout(reveal, 200);
    } else {
      window.addEventListener('load', function () {
        setTimeout(reveal, 200);
      }, { once: true, passive: true });
    }
    // Fallback : si load ne firen jamais (très lent / SPA), forcer après 5s
    setTimeout(reveal, 5000);
  } else {
    // Re-dispatch consent au cas où Shopify Pixels n'auraient pas reçu la valeur persistée
    writeConsent(existing.analytics, existing.marketing);
  }
})();
